import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  service: 'Precision Fade',
  outcome: 'Walk into any room with authority'
}, {
  service: 'Beard Sculpting',
  outcome: 'A jawline that commands respect'
}, {
  service: 'Hot Towel Treatment',
  outcome: 'Stress melts away, confidence rises'
}, {
  service: 'Style Consultation',
  outcome: "A look that's authentically you"
}, {
  service: 'The Full Experience',
  outcome: 'You become the best version of yourself'
}];
export function ComparisonTable() {
  return <section id="services" className="py-24 md:py-32 container mx-auto px-6 md:px-12" data-id="element-27">
      <motion.div className="glass-card rounded-sm overflow-hidden max-w-5xl mx-auto" initial={{
      opacity: 0,
      y: 50
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-28">
        <div className="grid grid-cols-2 border-b border-white/10 bg-white/5 p-6 md:p-8" data-id="element-29">
          <h3 className="text-xs md:text-sm tracking-[0.2em] uppercase text-gold font-medium" data-id="element-30">
            The Service
          </h3>
          <h3 className="text-xs md:text-sm tracking-[0.2em] uppercase text-gold font-medium" data-id="element-31">
            The Outcome
          </h3>
        </div>

        <div className="flex flex-col" data-id="element-32">
          {rows.map((row, index) => <motion.div key={index} className={`grid grid-cols-2 p-6 md:p-8 hover:bg-white/5 transition-colors ${index !== rows.length - 1 ? 'border-b border-white/5' : ''}`} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-33">
              <div className="font-serif text-lg md:text-xl text-white/90 pr-4" data-id="element-34">
                {row.service}
              </div>
              <div className="font-light text-white/60 text-sm md:text-base flex items-center" data-id="element-35">
                {row.outcome}
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}